/* PREMKEY — Add-on set v2.1 (2026-10-25). Pairs with snippets/premkey-bundles.liquid. Logged in the Theme Modifications Register. */
(function () {

  function pkaInit(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = document.querySelector('.js-product-form-main') || document.querySelector('.js-product-form');
    if (!form) return;
    function idInput() { return form.querySelector('input[name="id"]'); }
    function qtyInput() { return form.querySelector('input[name="quantity"]'); }
    function addButton() { return form.querySelector('[name="add"]'); }
    function sticky() { return document.querySelector('sticky-atc-panel button[type="submit"]'); }
    function waLink() { return form.querySelector('a.whatsapp-button'); }
    var addBtn = addButton();
    var stickyBtn = sticky();
    var rows = Array.prototype.slice.call(root.querySelectorAll('.pka-row'));
    var fmt = root.dataset.money || ('$' + '{' + '{amount}}');
    var title = root.dataset.title || '';
    var freeMin = parseInt(root.dataset.freeMin, 10) || 3000;
    var fee = parseInt(root.dataset.fee, 10) || 300;
    var origText = addBtn ? (addBtn.dataset.addToCartText || addBtn.textContent.trim()) : 'Add to cart';
    var origSticky = stickyBtn ? stickyBtn.textContent.trim() : '';
    var mainAvailable = true;

    function money(c) {
      var n = c / 100;
      var s = fmt.indexOf('no_decimals') > -1 ? Math.round(n).toString() : n.toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
    }
    function variantsOf(row) {
      var vs = [];
      try { vs = JSON.parse(row.dataset.variants); } catch (e) {}
      return vs;
    }
    function rowVariant(row) {
      var sel = row.querySelector('.pka-variant');
      var vid = sel ? parseInt(sel.value, 10) : parseInt(row.querySelector('.pka-check').value, 10);
      var vs = variantsOf(row);
      for (var i = 0; i < vs.length; i++) if (vs[i].id === vid) return vs[i];
      return vs[0] || null;
    }
    function rowsState() {
      var out = { on: [], off: [] };
      rows.forEach(function (row) {
        var cb = row.querySelector('.pka-check');
        var v = rowVariant(row);
        row.classList.toggle('is-on', cb.checked);
        if (!v) return;
        cb.value = v.id;
        var c = Math.max(v.c, v.p);
        row.querySelector('.pka-addon-price').textContent = money(v.p);
        var cmpEl = row.querySelector('.pka-addon-cmp');
        var subEl = row.querySelector('.pka-sub');
        cmpEl.textContent = money(c); cmpEl.hidden = c <= v.p;
        subEl.hidden = c <= v.p;
        if (c > v.p) subEl.querySelector('.pka-addon-save').textContent = money(c - v.p);
        var item = { id: v.id, p: v.p, c: c, r: v.r || 0, name: row.dataset.name || '', t: v.t || '' };
        (cb.checked ? out.on : out.off).push(item);
      });
      return out;
    }
    function label(n, total) { return 'Add ' + n + ' items · ' + money(total); } function fitLabel(b, n, total) { var r = document.createRange(); r.selectNodeContents(b); var rs = r.getClientRects(), tops = {}; for (var i = 0; i < rs.length; i++) tops[Math.round(rs[i].top)] = 1; if (!b.offsetWidth || Object.keys(tops).length > 1) b.textContent = 'Add ' + n + ' · ' + money(total); return b.textContent; }

    function updateWa(sel, total) {
      var a = waLink();
      if (!a) return;
      var mp = parseInt(root.dataset.price, 10) || 0;
      var text = 'I want to order:\n\n' + title + '\n' + money(mp);
      if (sel.length) {
        sel.forEach(function (s) {
          var nm = s.name + (s.t && s.t !== 'Default Title' ? ' (' + s.t + ')' : '');
          text += '\n+ ' + nm + ' (set price) ' + money(s.p);
        });
        text += '\nTotal: ' + money(total) + (total >= freeMin ? ' · FREE delivery' : '');
      }
      text += '\n\nName:\nAddress:\nPhone Number:';
      var base = a.getAttribute('href').split('?')[0];
      a.setAttribute('href', base + '?text=' + encodeURIComponent(text));
    }

    function update() {
      var mp = parseInt(root.dataset.price, 10) || 0;
      var mc = Math.max(parseInt(root.dataset.cmp, 10) || 0, mp);
      var st = rowsState();
      var sel = st.on;
      var total = mp, cmp = mc;
      sel.forEach(function (s) { total += s.p; cmp += s.c; });
      var n = 1 + sel.length;
      root.querySelector('.pka-total-label').innerHTML = 'Total for <span class="pka-count">' + n + '</span> item' + (n > 1 ? 's' : '');
      var tc = root.querySelector('.pka-total-cmp');
      tc.textContent = money(cmp); tc.hidden = cmp <= total;
      root.querySelector('.pka-total-price').textContent = money(total);
      var save = cmp - total;
      var saveEl = root.querySelector('.pka-save-text');
      if (save > 0) {
        saveEl.textContent = 'You save ' + money(save) + ' (' + Math.round(save * 100 / cmp) + '%)';
        saveEl.hidden = false;
      } else { saveEl.hidden = true; }
      var free = total >= freeMin;
      var ship = root.querySelector('.pka-ship');
      ship.classList.toggle('pka-ship--free', free);
      ship.classList.toggle('pka-ship--fee', !free);
      root.querySelector('.pka-ship-text').textContent = free ? 'FREE delivery' : (money(fee) + ' delivery');
      var nudge = root.querySelector('.pka-nudge');
      if (free) {
        nudge.hidden = true;
      } else {
        var best = null;
        st.off.forEach(function (o) { if (total + o.p >= freeMin && (!best || o.p < best.p)) best = o; });
        root.querySelector('.pka-nudge-text').textContent = best
          ? ('Tick the ' + best.name + ' and delivery is FREE')
          : ('Add ' + money(freeMin - total) + ' more for FREE delivery');
        nudge.hidden = false;
      }
      addBtn = addButton();
      if (addBtn && !addBtn.disabled && mainAvailable) {
        var t = sel.length ? label(n, total) : origText;
        addBtn.dataset.addToCartText = t;
        addBtn.textContent = t; if (sel.length) addBtn.dataset.addToCartText = fitLabel(addBtn, n, total);
      }
      stickyBtn = sticky();
      if (stickyBtn && !stickyBtn.disabled && mainAvailable) { stickyBtn.textContent = sel.length ? label(n, total) : origSticky; if (sel.length) fitLabel(stickyBtn, n, total); }
      updateWa(sel, total);
    }
    function setMainFromVariant(v) {
      if (!v) return;
      mainAvailable = v.available !== false;
      root.classList.toggle('pka--off', !mainAvailable);
      root.dataset.price = v.price;
      root.dataset.cmp = Math.max(v.compare_at_price || 0, v.price);
    }
    function showError(msg) {
      var el = root.querySelector('.pka-error');
      el.textContent = msg || 'Something went wrong. Please try again.';
      el.hidden = false;
      setTimeout(function () { el.hidden = true; }, 6000);
    }
    var busy = false;
    function addSet() {
      if (busy) return;
      var sel = rowsState().on;
      var q = qtyInput();
      var qty = q ? (parseInt(q.value, 10) || 1) : 1;
      var mainVid = parseInt((idInput() || {}).value, 10);
      if (!mainVid) return;
      var fd = new FormData();
      fd.append('items[0][id]', mainVid);
      fd.append('items[0][quantity]', qty);
      sel.forEach(function (s, i) {
        var k = 'items[' + (i + 1) + ']';
        fd.append(k + '[id]', s.id);
        fd.append(k + '[quantity]', 1);
        fd.append(k + '[properties][_pka_set]', title);
        fd.append(k + '[properties][_pka_main]', root.dataset.product);
        fd.append(k + '[properties][_pka_main_v]', mainVid);
        fd.append(k + '[properties][_pka_main_h]', root.dataset.handle || '');
        fd.append(k + '[properties][_pka_real]', s.r);
      });
      var drawer = document.querySelector('cart-drawer');
      var sections = 'cart-icon-bubble';
      var dSec = drawer && drawer.closest('.shopify-section');
      if (dSec) sections += ',' + dSec.id.replace('shopify-section-', '');
      fd.append('sections', sections);
      fd.append('sections_url', window.location.pathname);
      busy = true;
      addBtn = addButton(); stickyBtn = sticky();
      var btns = [addBtn, stickyBtn].filter(Boolean);
      btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });
      var routes = (window.theme && theme.routes) || {};
      var afterAtc = (window.theme && theme.settings && theme.settings.afterAtc) || 'drawer';
      fetch(routes.cartAdd || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          var d = res.d;
          if (!res.ok || d.status) {
            showError(typeof d.description === 'string' ? d.description : d.message);
            return;
          }
          var PF = customElements.get('product-form');
          if (PF && PF.updateCartIcon) PF.updateCartIcon(d);
          if (afterAtc === 'page') {
            setTimeout(function () { window.location.href = routes.cart || '/cart'; }, 300);
          } else if (drawer && drawer.renderContents) {
            setTimeout(function () { drawer.renderContents(d, afterAtc === 'drawer'); }, 300);
          }
          form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: mainVid } }));
        })
        .catch(function () { showError(); })
        .finally(function () {
          busy = false;
          btns.forEach(function (b) { b.classList.add('is-success'); b.removeAttribute('aria-disabled'); });
          setTimeout(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.classList.remove('is-success'); }); }, 1400);
        });
    }

    root.addEventListener('change', update);
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!mainAvailable) return;
      if (!rowsState().on.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addSet();
    }, true);
    document.addEventListener('on:variant:change', function (e) {
      if (e.detail && e.detail.variant) setMainFromVariant(e.detail.variant);
      setTimeout(update, 30);
    });
    update();
  }
  document.querySelectorAll('.pka[data-product]').forEach(pkaInit);
})();
